module.exports = __webpack_public_path__ + "img/og-screen-5.dbfa7c0c.png";